"use client"

import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { Icons } from "@src/components"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "next/navigation"
import useRouterClient from "@src/hooks/use-router-client"
import Filter from "./filter"

type Props = {
  /** Preserve keyword / subcategory filters when sorting. */
  preserveKeyword?: boolean
}

/** Sort controls for product listing — kept visible during grid skeleton. */
export default function ProductSortBar({ preserveKeyword = true }: Props) {
  const { t } = useTranslation()
  const { router } = useRouterClient()
  const searchParams = useSearchParams()
  const sortBy = searchParams?.get("sortBy") || ""

  const handleChangeFilter = ({
    key,
    value,
    direction: nextDirection = "asc"
  }) => {
    const newParams = new URLSearchParams(searchParams?.toString() || "")
    newParams.set("page", "1")
    newParams.set(key, value)
    newParams.set("direction", nextDirection)
    if (!preserveKeyword) {
      newParams.delete("keyword")
    }
    router.push(`?${newParams.toString()}`)
  }

  return (
    <Stack
      gap={2}
      my={{
        xs: 2,
        md: 3
      }}
      alignItems="center"
    >
      <Icons name="sort" />
      <Typography variant="body1">{t("sort_by")}</Typography>
      <Filter value={sortBy} onChange={handleChangeFilter} />
    </Stack>
  )
}
